var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ctrl-affiliate-download-bank-csv"},[_c('h2',[_vm._v("報酬処理用CSVダウンロード")]),_c('el-row',[_c('el-col',[_c('DownloadBankCsv')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }